<template>
    <div class="upload--custom">
        <div
            v-for="(item,index) in data[header.field]"
            :key="index"
            class="c-flex c-upload-item"
        >
            <div
                v-if="header.props.uploadType ==='image'"
                class="imgBox"
                @click="previewImg(item.url)"
            >
                <img
                    class="el-upload-list__item-thumbnail"
                    :src="item.url"
                    alt=""
                >
            </div>

            <video
                v-else-if="header.props.uploadType ==='video'"
                :src="item.url"
                controls="controls"
                class="video"
            >您的浏览器不支持视频播放</video>

            <audio
                v-else-if="header.props.uploadType ==='audio'"
                :src="item.url"
                controls="controls"
                class="audio"
            >您的浏览器不支持音频播放</audio>

            <div
                v-else-if="header.props.uploadType ==='file'"
                class="imgBox"
                @click="download(item.url)"
            >
                <i class="el-icon-tickets" />
            </div>
        </div>
        <!-- 预览 -->
        <previewImg
            :visible="dialogVisible"
            :url="imageUrl"
            @close="dialogVisible=false"
        />
    </div>
</template>

<script>
import previewImg from './previewImg.vue'

export default {
    name: 'RenderCustomUpload',
    components: { previewImg },
    props: {
        data: {
            type: Object,
            default: null
        },
        header: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            dialogVisible: false,
            imageUrl: ''
        }
    },

    computed: {
    },

    created() {
    },

    methods: {
        previewImg(url) {
            this.dialogVisible = true
            this.imageUrl = url
        },
        download(item) {
            window.open(item, '_blank')
        }
    }
}
</script>
<style rel="stylesheet/less" lang="less">
.upload--custom {
    display: flex;
    flex-wrap: wrap;
    margin-left: 20px;
    position: relative;

    .c-upload-item {
        margin-right: 10px;
    }

    .c-flex {
        display: flex;
        flex-wrap: wrap;

        .imgBox {
            width: 80px;
            height: 80px;
            border: 1px solid #c0ccda;
            border-radius: 6px;
            cursor: pointer;
            display: flex;
            justify-content: center;
            align-items: center;

            .el-icon-tickets {
                font-size: 24px;
            }

            img {
                width: 100%;
                height: 100%;
            }
        }

        .video {
            width: 180px;
            height: 100px;
            margin-bottom: 10px;
        }

        .audio {
            width: 180px;
            margin-bottom: 10px;
        }
    }
}
</style>
